export const myNewsNewsletterId = "myNEWS";
export const myNewsNewsletterUrl = "/mynews?module=newsletter_index&pgtype=others";
export const myNewsNewsletterTitle = "myNEWS";
export const myNewsNewsletterPreviewUrl =
  "https://assets-v2.i-scmp.com/production/newsletter-sample-mynews/index.html";
